module.exports = __webpack_public_path__ + "static/img/entorno.b0e6bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entorno.png
// module id = Y5/+
// module chunks = 5